// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__4nq27","notes":"Notes_notes__1BTgw"};